import { createMetricsFactory } from 'metrics-js';
export const Metrics = createMetricsFactory('reporting-reports', {
  library: 'reporting-reports'
});